import React, { ReactElement } from 'react';

import { Button } from "@material-ui/core";
import { createStyles, makeStyles, withStyles, WithStyles } from '@material-ui/core/styles';

import { AlmeMarkdownResponseNext } from "../../AlmeResponse/AlmeResponse";
import { ResponseAction } from "@alme/types/response/ResponseAction";

import confirmationOptionStyles from './ChangeTenantConfirmation.styles';
import { FocusComponentProps } from '../../../models/ComponentProps';
import { ChangeTenantConfirmationConfig } from './ChangeTenantConfirmationConfig';
import { CookieLoader } from "@alme/storage-ts/CookieLoader";

export interface ChangeTenantAppEvent {
    Name: string;
    parameters: {
        NewClientAccessKey: string;
        OldClientAccessKey: string;
        Initiator: string;
        InputToResend: string;
    };
}

interface ChangeTenantConfirmationOption {
    DisplayText: string;
    NewClientAccessKey: string;
    NewTenantUrl: string;
}

export interface ChangeTenantConfirmationResponseAction extends ResponseAction {
    PreviousInput: string;
    options: ChangeTenantConfirmationOption[];
    Name: "ChangeTenantConfirmation";
}

const useStyles = makeStyles(() =>
    createStyles({
        root: {
        },
    }),
);

interface AlmeChangeTenantConfirmationProps extends WithStyles<typeof confirmationOptionStyles> {
    response: AlmeMarkdownResponseNext;
    focusProps?: FocusComponentProps;
    responseId: string;
    almeConfig: ChangeTenantConfirmationConfig;
}

const ChangeTenantConfirmation: React.FC<AlmeChangeTenantConfirmationProps> = (props: AlmeChangeTenantConfirmationProps) => {
    const classes = useStyles();
    const responseRevision = (props.responseId || props.response.responseRevision).toString();

    const responseAction = props.response.responseActions?.find(action => action.Name === "ChangeTenantConfirmation") as ChangeTenantConfirmationResponseAction;
    if (!responseAction) {
        return null;
    } else {
        return (
            <>
                {responseAction.options.reduce((elements: ReactElement[], option): ReactElement[] => {
                    return elements.concat(
                        buildOptionButton(option.DisplayText, option.NewClientAccessKey, option.NewTenantUrl, responseRevision, props, responseAction.PreviousInput, classes.root));
                }, [] as ReactElement[])}
            </>
        );
    }
};

export default withStyles(confirmationOptionStyles)(ChangeTenantConfirmation);

function buildOptionButton(displayText: string, accessKey: string, url: string, responseRevision: string, props: AlmeChangeTenantConfirmationProps, previousInput: string, rootClass: string) {

    const savedAccessKey = new CookieLoader<string>('verintAccessKey');
    const oldAccessKey = savedAccessKey.GetStorage();
    const changeTenantAppEvent = new CookieLoader<ChangeTenantAppEvent>('changeTenantAppEvent');
    const inputToResend = new CookieLoader<string>('inputToResend');

    const appEvent = {
        Name: "ChangeTenant",
        parameters: {
            NewClientAccessKey: accessKey,
            OldClientAccessKey: oldAccessKey,
            Initiator: "Conversation",
            InputToResend: previousInput,
        },
    } as ChangeTenantAppEvent;

    const setNewKey = () => {
        changeTenantAppEvent.UpdateStorage(appEvent);
        savedAccessKey.UpdateStorage(accessKey);
        inputToResend.UpdateStorage(previousInput);
    };

    return (
        <Button
            id={`alme-iva-card-${responseRevision}-change-tenant-confirmation-${accessKey}`}
            key={`config-option-${accessKey}`}
            color={props.almeConfig.optionButton.styles.button.color}
            variant={props.almeConfig.optionButton.styles.button.variant}
            className={`${props.classes.confirmationOption} ${rootClass}`}
            onClick={setNewKey}
            target="_self"
            href={url}
            fullWidth
            {...props.focusProps}
        >{displayText}</Button>
    );
}